export const selectIsCardUpdating = ({ pipelineCards: { isCardUpdating } }) => isCardUpdating
